import React from 'react';
import { ShieldCheck, Clock, Users, FileCheck, Award } from 'lucide-react';
const indicators = [{
  icon: Users,
  text: 'Trusted by UK Legal Professionals'
}, {
  icon: Clock,
  text: 'Fast Turnaround Times'
}, {
  icon: FileCheck,
  text: 'Fully Compliant Reports'
}, {
  icon: ShieldCheck,
  text: 'ISO 27001 Certified'
}, {
  icon: Award,
  text: '15,000+ Reports Delivered'
}];
export function TrustBadges() {
  return <div className="bg-teal-50/60 border-y border-teal-100/80" data-id="element-456">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-5 md:py-6" data-id="element-457">
        {/* Desktop: horizontal row with equal spacing */}
        <div className="hidden md:flex items-center justify-between" data-id="element-458">
          {indicators.map((item, index) => <div key={index} className="flex items-center gap-2.5" data-id="element-459">
              <item.icon className="h-5 w-5 text-teal-600 flex-shrink-0" data-id="element-460" />
              <span className="text-sm font-semibold text-ink-700 whitespace-nowrap" data-id="element-461">
                {item.text}
              </span>
            </div>)}
        </div>

        {/* Mobile: horizontal scroll */}
        <div className="md:hidden -mx-5 px-5 overflow-x-auto scrollbar-hide" data-id="element-462">
          <div className="flex items-center gap-8 min-w-max py-1" data-id="element-463">
            {indicators.map((item, index) => <div key={index} className="flex items-center gap-2.5" data-id="element-464">
                <item.icon className="h-5 w-5 text-teal-600 flex-shrink-0" data-id="element-465" />
                <span className="text-sm font-semibold text-ink-700 whitespace-nowrap" data-id="element-466">
                  {item.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}